import React from 'react';
import { TripDates } from '../../../../../services/trips/api/tripsApi';
import { calculateDaysRemaining } from '../../../../../services/trips/utils/dateUtils';
import './DaysRemaining.css';

interface DaysRemainingProps {
  dates: TripDates;
  className?: string;
}

const DaysRemaining: React.FC<DaysRemainingProps> = ({ dates, className = '' }) => {
  const days = calculateDaysRemaining(dates);
  
  if (days === null || days <= 0) {
    return null;
  }

  return (
    <div className={`days-remaining ${className}`}>
      ⏰ {days} {days === 1 ? 'day' : 'days'} remaining
    </div>
  );
};

export default DaysRemaining;

